// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./$.is-regexp')
  , defined  = require('./$.defined');

module.exports = function(that, searchString, NAME){
  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/$.string-context.js
// module id = 77
// module chunks = 0